export default "__VITE_ASSET__DZ2ZQ4kx__"